import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// On route change: scroll to the hash target when the URL has one, otherwise
// scroll to the top. Landing sections are heavy and can mount a tick after the
// route change, so we retry briefly until the target exists. The fixed landing
// header is cleared via each section's `scroll-mt-*`, which scrollIntoView honors.
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
      return;
    }

    let timer;
    let attempts = 0;
    const tryScroll = () => {
      const el = document.getElementById(decodeURIComponent(hash.slice(1)));
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
      attempts += 1;
      if (attempts <= 40) {
        timer = window.setTimeout(tryScroll, 50);
      }
    };
    tryScroll();

    return () => window.clearTimeout(timer);
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
